// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';
import 'cleave.js/dist/addons/cleave-phone.in';

// Containers Injection
import { Currency, PageWrapper } from '../../containers/componentsInjection';

export const ServicesFormPage = ({
  history,
  service,
  isActive,
  validation,
  setIsActive,
  isDisponibleInSite,
  setIsDisponibleInSite,
}) => {
  return (
    <PageWrapper title={service.id ? 'Editar serviço' : 'Adicionar serviço'}>
      <Row>
        <Col>
          <Form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Card>
              <div className="live-preview">
                <CardBody>
                  <Row>
                    <Col md={8}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Nome
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.nameInput || ''}
                        />
                        {validation.touched.nameInput &&
                        validation.errors.nameInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.nameInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <label htmlFor="priceInput" className="form-label">
                          Preço
                        </label>
                        <Currency
                          id="priceInput"
                          onChange={(e, valueWithoutMask) => {
                            validation.handleChange({
                              target: {
                                name: 'priceInput',
                                value: valueWithoutMask,
                              },
                            });
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.priceInput || 0}
                        />
                        {validation.touched.priceInput &&
                        validation.errors.priceInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.priceInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Descrição
                        </Label>
                        <Input
                          type="textarea"
                          className="form-control"
                          id="descriptionInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.descriptionInput || ''}
                        />
                        {validation.touched.descriptionInput &&
                        validation.errors.descriptionInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.descriptionInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={12}>
                      <div>
                        <div className="form-check form-switch mb-3">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="isDisponibleInSite"
                            onChange={() =>
                              setIsDisponibleInSite(!isDisponibleInSite)
                            }
                            onBlur={validation.handleBlur}
                            checked={isDisponibleInSite}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="isDisponibleInSite"
                          >
                            Disponibilizar no site
                          </Label>
                        </div>
                      </div>
                    </Col>

                    <Col md={12}>
                      <div>
                        <div className="form-check form-switch mb-3">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="isActive"
                            onChange={() => setIsActive(!isActive)}
                            onBlur={validation.handleBlur}
                            checked={isActive}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="isActive"
                          >
                            Ativo
                          </Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Col md={12}>
                    <div className="text-end d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-link me-3"
                        onClick={() => history.goBack()}
                      >
                        Cancelar
                      </button>
                      <button type="submit" className="btn btn-primary">
                        {service.id ? 'Editar' : 'Salvar'}
                      </button>
                    </div>
                  </Col>
                </CardFooter>
              </div>
            </Card>
          </Form>
        </Col>
      </Row>
    </PageWrapper>
  );
};
